// Shared constants + tiny helpers between UserDialog and InviteDialog.
// Kept in one place so role labels and password generation can't drift
// between the create/edit form and the invite form.

export const ROLES = [
  { value: "ADMIN", label: "ADMIN — full control (manage users, seasons, all data)" },
  { value: "SECRETARY", label: "SECRETARY — score competitions, manage photographers & comps" },
  { value: "VIEWER", label: "VIEWER — read-only (sees results & stats, no edit buttons)" },
  { value: "MEMBER", label: "MEMBER — read-only + linked to one photographer's results" },
];

// Invite flow never allows ADMIN — admins are created manually after acceptance.
export const INVITE_ROLES = ROLES.filter((r) => r.value !== "ADMIN");

// Generate a 12-character mixed-case password that's easy to read aloud
// (no ambiguous 0/O/1/l/I) — handed to the admin when resetting somebody.
export function generatePassword(length = 12) {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789!@#$%";
  const out = [];
  const cryptoObj = window.crypto || window.msCrypto;
  if (cryptoObj && cryptoObj.getRandomValues) {
    const bytes = new Uint32Array(length);
    cryptoObj.getRandomValues(bytes);
    for (let i = 0; i < length; i++) out.push(chars[bytes[i] % chars.length]);
  } else {
    for (let i = 0; i < length; i++) {
      out.push(chars[Math.floor(Math.random() * chars.length)]);
    }
  }
  return out.join("");
}
